// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ImprovePageFormFields } from "@steiner/App/Components/ImprovePageLink/ImprovePageLinkModal";
import xLoadingOverlay from "@steiner/App/Handlers/XNG/LoadingOverlay";
import { submitPageFeedbackService } from "@steiner/App/Services/SubmitPageFeedback";

type HandlerType = ApiHandler<
    ImprovePageFormFields & HasOnSuccess & HasOnError<string>,
    ServiceResult<any> & {
        errorMessage?: string;
    }
>;

export const BeginSubmittingPageFeedback: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", id: "pageFeedback_saveInfo" }));
};

export const submitFeedback: HandlerType = async props => {
    const pageFeedbackResult = await submitPageFeedbackService(props.parameter);
    props.apiResult = pageFeedbackResult as any;
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch(xLoadingOverlay({ key: "clear", id: "pageFeedback_saveInfo" }));
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch(xLoadingOverlay({ key: "clear", id: "pageFeedback_saveInfo" }));
        props.parameter.onError?.(props.apiResult?.errorMessage);
    }
};
export const chain = [BeginSubmittingPageFeedback, submitFeedback, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const submitPageFeedback = createHandlerChainRunner(chain, "submitPageFeedback");
export default submitPageFeedback;
